<div class="kodit-card-tab">
  <p-tabView
    [(activeIndex)]="activeIndex"
    (activeIndexChange)="handleIndexChange($event)"
  >
    <p-tabPanel header="Ulazna otpremnica"></p-tabPanel>
    <p-tabPanel header="Izlazna prijemnica"></p-tabPanel>
  </p-tabView>

  <div [ngSwitch]="activeIndex">
    <div *ngSwitchCase="0">
      <kodit-page>
        <kodit-eotpremnica-table
          [vrstaOtpremnice]="VrstaDokumentaOtpremnica.ULAZNA"
        ></kodit-eotpremnica-table>
      </kodit-page>
    </div>
    <div *ngSwitchCase="1">
      <kodit-page>
        <kodit-eprijemnica-table
          [vrstaOtpremnice]="VrstaDokumentaOtpremnica.IZLAZNA"
        ></kodit-eprijemnica-table>
      </kodit-page>
    </div>
  </div>
</div>
